import { combineReducers } from "redux";
import user from "./ApiCall/reducer";

const appReducer = combineReducers({
  user
});

export default appReducer;